module.exports = __webpack_public_path__ + "img/avatar3.d73336a4.png";